export const LOB_RAILS = 'rails';

export const EVENT_NAME_PAGE_RENDERED = 'page-rendered';
export const EVENT_TYPE_PAGE = 'page';

export const STORE_ID_MMT = 'MMT';
export const ORGANISATION_MMT = 'MMT';
export const BU_GROUND_TRANSPORT = 'ground_transport';
export const TRAFFIC_SOURCE_ORGANIC = 'organic';

export const PDT_SCHEMA_ID = 173469;
export const PDT_SCHEMA_NAME = 'mmt_rails_b2c_pdt_client_logging_v2';

export const RIS_LTS_SCHEMA_ID = 176533;
export const RIS_LTS_SCHEMA_NAME = 'base_event_ris_lts_logging_on_schema_blocks';

export const RIS_PDT_SCHEMA_ID = 164305;
export const RIS_PDT_SCHEMA_NAME = 'mmt_ris_b2c_pdt_client_logging';

export const PAGE_TYPE_TEMPLATE = 'template';
export const PAGE_TYPE_FUNNEL = 'funnel';
export const FUNNEL_STEP_DETAIL = 'detail';
export const FUNNEL_STEP_LANDING = 'landing';
export const FUNNEL_SOURCE_SEO = 'seo';
export const PAGE_NAME_HOME = 'home';
export const PAGE_NAME_SEO = 'seo';

export const SEO_PAGE_EVENT = {
  ROUTE: 'seo:rails:route:index',
  TRAIN: 'seo:rails:train:index',
  STATION: 'seo:rails:station:index',
  TRAIN_TYPE: 'seo:rails:train-type:index',
  SEAT_AVAILABILITY: 'seo:rails:seat-availability:index',
  PNR_SEARCH: 'seo:rails:pnr:search',
  LTS_SEARCH: 'seo:rails:lts:search',
  LTS_DETAILS: 'seo:rails:lts:details',
  LANDING: 'funnel:railsris:railsrislanding'
} as const;

export const XDM_PAGE_NAME = {
  ROUTE: 'rails_seo_route',
  TRAIN: 'rails_seo_train',
  STATION: 'rails_seo_station',
  TRAIN_TYPE: 'rails_seo_train_type',
  SEAT_AVAILABILITY: 'rails_seo_seat_availability',
  PNR: 'rails_seo_PNR',
  LTS: 'rails_seo_LTS',
  LTS_DETAILS: 'rails_LTS_details',
  LANDING: 'railsrislanding'
} as const;

export const IRCTC_INFO_PAGE_EVENT = {
  ACC_CREATION: 'seo:rails:irctc-info:acc_creation',
  FORGOT_USERNAME: 'seo:rails:irctc-info:forgot_username',
  FORGOT_PASSWORD: 'seo:rails:irctc-info:forgot_password',
  IRCTC_LOGIN: 'seo:rails:irctc-info:irctc_login'
} as const;

export const SEO_ROUTE_PAGE = SEO_PAGE_EVENT.ROUTE;
export const SEO_TRAIN_PAGE = SEO_PAGE_EVENT.TRAIN;
export const SEO_STATION_PAGE = SEO_PAGE_EVENT.STATION;
export const SEO_SEAT_AVAILABILITY_PAGE = SEO_PAGE_EVENT.SEAT_AVAILABILITY;
export const SEO_TRAIN_TYPE_PAGE = SEO_PAGE_EVENT.TRAIN_TYPE;
export const SEO_LANDING_PAGE = SEO_PAGE_EVENT.LANDING;
export const IRCTC_PAGE_NAME = IRCTC_INFO_PAGE_EVENT.ACC_CREATION;

export const LOCUS_API_ENDPOINT = 'https://railways.makemytrip.com/api/mobile/search/getLocusId';
